import {DesignPreviewController} from './design-preview.controller';
import template from './design-preview.template.html';

export const DesignPreviewComponent = {
    controller: DesignPreviewController,
    templateUrl: template,
    bindings: {
        editable: '<',
        base: '<'
    }
};



// WEBPACK FOOTER //
// ./src/js/components/design-preview/design-preview.component.js